import { createEffect } from 'effector'
import type { ContentTypeParams, SeoMetadataParams } from '../../index.h'
import type { PageParams } from '../../interfaces/fxParams'
import type { GenericApiResponse } from '../../interfaces/generic'
import { stateful } from '../../lib/stateful'
import type { ContentList } from '../content'
import type { OtherTag } from './index.h'

export type { OtherTag }

type EntityParams = {
  id: string
}

type BaseParams = EntityParams & PageParams

export const base = {
  getOneFx: createEffect<
    EntityParams & ContentTypeParams & SeoMetadataParams,
    OtherTag,
    GenericApiResponse<Error>
  >(),
  getContentFx: createEffect<
    BaseParams,
    ContentList,
    GenericApiResponse<Error>
  >(),
}

export const pageable = (initial?: BaseParams) =>
  stateful({
    effect: base.getContentFx,
    initial,
    methods: {
      limit: (n: number, params) => ({ ...params, limit: n }),
      offset: (n: number, params) => ({ ...params, offset: n }),
      next: (_: void, params) => ({
        ...params,
        offset: (params.offset ?? 0) + (params.limit ?? 36),
      }),
      prev: (_: void, params) => ({
        ...params,
        offset: Math.max((params.offset ?? 0) - (params.limit ?? 36), 0),
      }),
    },
  })
